import { ActionCard } from "./ActionCard.js";
import { ACTION_CARD_COUNTS } from "@/game-rules/constants/actionCardCounts.js";

export class PalmeArriere extends ActionCard {
    static typeId = "PALME_ARRIERE";
    static cardName = "Palme Arrière";
    static colorHex = "#FFAA00";
    static countInDeck = ACTION_CARD_COUNTS.PALME_ARRIERE;
    static description = "Inversez l’un de vos moutons avec l'entité qui se trouve immédiatement derrière lui.";

    isValidOn(slotIndex, gameState) {
        if (slotIndex === 5) return false;
        const duck = gameState.lineOfFire[slotIndex];

        // Can only target own duck that can go to the right
        return duck.team?.id === gameState.getCurrentPlayerTeamId();
    }

    resolve(slotIndex, gameState) {
        gameState.swapDuck(slotIndex, "right");
    }
}
